import React from "react"
import { Container } from "reactstrap"

const Covid = () => (
  <div className="covid">
    <Container>
      <div class="image-box">
        <div>
          <strong>Due To COVID-19 We Ask All Guest To Please:</strong>
          <br />
          1. Order and Pay Online to minimize contact
          <br />
          2. Wear A Mask When Picking Up Your Order
          <br />
          3. Maintain 6' Social Distance Whenever Possible
          <br />
          4. Be Sure to Perform Self Checks Before Arriving
          <br />
          5. Should you not feel well, you can elect to have your order
          delivered to your home.
          <br />
          Thank you for your support and stay safe
        </div>
      </div>
    </Container>
  </div>
)

export default Covid
